<template>
  <div class="hotel-card-home">
    <router-link :to="goToHotel(hotel)"
      class="hotel-card-home__link block rounded overflow-hidden no-underline text-grey">
      <div class="coverImage" v-lazy:background-image="coverExist ? hotelCover(hotel) : require('@/assets/images/default-room.jpg')"></div>
      <div class="hotel-card-home__content">
        <div :class="Number(hotel.stars) > 0 ? 'flex items-center' : 'hidden'" style="margin-bottom: 0.25rem;">
          <div class="flex rounded-full bg-orange h-4 w-4 justify-center">
            <i class="owl-rank-star text-white text-xs" style="margin-top: 1px;"></i>
          </div>
          <span class="text-xs text-grey-darkest font-medium ml-4">{{ $t('unit.star', [$t('number')[Number(hotel.stars)]]) }}</span>
        </div>
        <h5 class="font-bold text-grey-darkest mb-4">{{ hotel.hotelNameLocal }}</h5>
        <div v-if="hotel.hotelNameEN && selectedLang !== 'en'" class="text-sm mb-8 text-grey-darkest font-bold">{{ hotel.hotelNameEN }}</div>
        <div class="flex items-center mb-8">
          <div class="text-xs text-grey-darker">{{ hotel.placesText }}</div>
          <span class="mx-4">|</span>
          <div class="text-grey-darker text-xs">{{ hotel.hotelType.name }}</div>
        </div>
        <div class="flex items-center">
          <div class="font-bold text-grey-darkest mb-8">{{ currencySign }} {{ Number(hotel.price) | currencyConvert({inputCurrency: hotel.currency, listInteger: true}) }}<i class="owl-caret-top text-grey"></i></div>
          <img v-if="hotel.type === 'hotel' && hotel.tripAdvisor" :src="hotel.tripAdvisor.logo" style="width: 110px;" :alt="`${hotel.hotelName} - tripAdvisor`">
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import imgInfo from '@/utils/imgInfo'
export default {
  name: 'hotelCardHome',
  props: {
    hotel: {
      type: Object
    }
  },
  data () {
    return {
      MAGNIFACATION: 1.5,
      coverExist: false
    }
  },
  computed: {
    ...mapGetters({
      selectedLang: 'user/selectedLang',
      currencySign: 'user/currencySign',
      selectedCurrency: 'user/selectedCurrency',
      initWidth: 'initWidth'
    }),
    hotelCardHomeImageWidth () {
      if (this.initWidth >= 1200) {
        return 280
      } else if (this.initWidth < 1200 && this.initWidth >= 992) {
        return 311
      } else if (this.initWidth < 992 && this.initWidth >= 768) {
        return 172
      } else {
        return 380
      }
    }
  },
  methods: {
    goToHotel: function (hotel) {
      return {
        name: 'HotelDetail',
        params: { hotelId: hotel.hotelUUID },
        query: {
          ...this.$route.query,
          externalId: hotel.hotelUUID,
          searchId: hotel.hotelUUID,
          search: hotel.hotelNameLocal,
          searchType: 'hotel',
          source: hotel.source
        }
      }
    },
    hotelCover: function (hotel) {
      if (hotel.image) {
        return `${hotel.image}?width=${this.hotelCardHomeImageWidth * this.MAGNIFACATION}&format=webp`
      }
      return require('@/assets/images/default-room.jpg')
    }
  },
  async mounted () {
    const exist = await imgInfo.exist(this.hotel.image)
    this.coverExist = exist
  }
}
</script>
<style lang="sass" scoped>
.hotel-card-home
  &__content
    @apply py-8 px-4
  .coverImage
    @apply bg-grey-lightest
    border-radius: 1.25rem
    padding-top: imageRatio(324, 192)
    background:
      position: center
      repeat: no-repeat
      size: cover
</style>
<style lang="sass">
.hotel-card-home
  // [class^="owl-rank-star"]:before
  //   margin-bottom: 0.2rem
</style>
